import { isNullOrEmpty, isNullOrWhiteSpace } from "../fable_modules/fable-library.3.7.20/String.js";
import { create, match } from "../fable_modules/fable-library.3.7.20/RegExp.js";

export const isNotNullOrWhitespace = (arg_1) => (!isNullOrWhiteSpace(arg_1));

export const isNotNullOrEmpty = (arg_1) => (!isNullOrEmpty(arg_1));

function validateRegex(regex, str) {
    let tupledArg;
    if (isNotNullOrEmpty(str)) {
        return ((tupledArg = [str, regex], match(create(tupledArg[1]), tupledArg[0]))) != null;
    }
    else {
        return false;
    }
}

export const isOnlyText = (str) => validateRegex("^[a-öA-Ö]*$", str);

export const isOnlyTextAndWhitespace = (str) => validateRegex("^[a-öA-Ö\\s]*$", str);

export const isOnlyNumbers = (str) => validateRegex("^[0-9]*$", str);

export const isOnlyNumbersAndWhitespace = (str) => validateRegex("^[0-9\\s]*$", str);

export const isValidEmail = (str) => validateRegex("(?:[a-zA-Z0-9!#$%\u0026\u0027*+/=?^_`{|}~-]+(?:\\.[a-zA-Z0-9!#$%\u0026\u0027*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])", str);

export const isOnlyPositiveInteger = (str) => validateRegex("^\\d+$", str);

export const isValidPeppolId = (str) => validateRegex("\\d+:\\d+", str);

export const isOnlyNumberWithPossibleDecimals = (str) => validateRegex("^[0-9]*[,|.]?[0-9]{0,2}$", str);

export const is_yyyy_mm_dd = (str) => validateRegex("^([0-9]{4})-([0-1][0-9])-([0-3][0-9])$", str);

export const is_yyyy_mm_dd_hh_mm_ss = (str) => validateRegex("^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$", str);

export function isSQLBoolean(_arg) {
    switch (_arg) {
        case "0":
        case "1": {
            return true;
        }
        default: {
            return false;
        }
    }
}

